// extracted by mini-css-extract-plugin
export default {"addToCartControl":"DZ-z","giftCard":"EZ-z","btnContainer":"FZ-z","cartButton":"GZ-z","disabled":"HZ-z"};